import { type DateRange as CalendarRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';

import { Calendar } from '@/components/ui/calendar';
import { resolveDateFnsLocale } from '@/i18n/dateFnsLocales';

import { DATE_RANGE_CALENDAR_CLASS_NAMES } from './calendarClassNames';
import { DateRangeDayButton } from './DateRangeDayButton';

const CALENDAR_COMPONENTS = { DayButton: DateRangeDayButton };

interface Props {
  selected: CalendarRange | undefined;
  onSelect: (range: CalendarRange | undefined) => void;
  isDayDisabled?: (day: Date) => boolean;
  startMonth?: Date;
  endMonth?: Date;
  numberOfMonths: 1 | 2;
}

export const DateRangeCalendar = ({
  selected,
  onSelect,
  isDayDisabled,
  startMonth,
  endMonth,
  numberOfMonths,
}: Props) => {
  const { i18n } = useTranslation();

  return (
    <Calendar
      mode="range"
      resetOnSelect
      selected={selected}
      onSelect={onSelect}
      disabled={isDayDisabled}
      defaultMonth={selected?.from}
      startMonth={startMonth}
      endMonth={endMonth}
      numberOfMonths={numberOfMonths}
      locale={resolveDateFnsLocale(i18n.language)}
      classNames={DATE_RANGE_CALENDAR_CLASS_NAMES}
      components={CALENDAR_COMPONENTS}
    />
  );
};
